import { render, staticRenderFns } from "./CoursewareShelfImportWidget.vue?vue&type=template&id=8278e046&"
import script from "./CoursewareShelfImportWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareShelfImportWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports